import styled from 'styled-components';
import { aiManagementMenuItems, aiManagementMenuSurface } from 'styles/ai_management_menu';

interface ContainerProps {
  barColor: string;
  menuOpen: boolean;
}

export const Container = styled.div<ContainerProps>`
  width: 300px;
  min-width: 300px;
  border: 1px solid ${(props) => props.theme.$gray300};
  border-top: 3px solid ${(props) => props.barColor};
  z-index: ${(props) => (props.menuOpen ? 5 : 'auto')};

  .column-drag-handle {
    cursor: grab;
  }

  .column-empty {
    min-height: 64px;
    border: 1px dashed ${(props) => props.theme.$gray400};
  }

  .dropdown-menu {
    ${aiManagementMenuSurface}
    ${aiManagementMenuItems}
  }
`;
